import type { SetupResponse } from "@joogoos/contracts";

/**
 * **Set up, step 1** — the address letters leave from (22, ADR 0036).
 *
 * First because nothing else on the page can happen without it: Joogoos never writes to a stranger from a domain
 * of its own, so until a mailbox is connected there is no letter to draft.
 */

/**
 * Where letters leave from. The one thing on this page that is set somewhere else entirely.
 *
 * Which is why the words *Business → Customers* are a button rather than a caption: a screen that tells somebody
 * where to go and makes them find it has given directions instead of a door.
 */
export function Mailbox({ d, onMailbox }: { d: SetupResponse; onMailbox: () => void }) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex flex-wrap items-center gap-2.5">
        <span className="text-[12.5px]">{d.signsAs ?? "No mailbox connected yet."}</span>
        <button onClick={onMailbox} className="text-[11.5px] font-medium text-coral ml-auto">
          {d.signsAs ? "Business → Customers" : "Connect one →"}
        </button>
      </div>
      {/* The decision is made once, before the first letter, so it is said where the first step is (2026-10-21). */}
      {d.signsAs ? null : (
        <p className="text-xs text-muted leading-relaxed">
          Best a mailbox kept only for letters to new customers, on a second domain of yours if you have one, so your
          everyday email is never the one a provider limits.
        </p>
      )}
    </div>
  );
}
